<template>
  <div class="Certificate_setting">
    <el-select v-model="templateType" placeholder="请选择" style="margin-left:20px;margin-top:20px">
      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
      </el-option>
    </el-select>
    <el-button type="primary" style="margin-left:20px;" @click="loading()">查询</el-button>
    <el-button type="primary" style="margin-left:20px;" @click="qdfun()">修改</el-button>
    <el-button type="primary" style="margin-left:20px;" @click="drawer = true" >上传</el-button>

    <ul style="width: 100%;height: calc(100% - 80px);margin-top:15px">
      <li v-for="(item,i) in data" :key="i" @click="qh(i,item.keyNo)">
        <img :src="item.templateBack" alt="" style="width:100%;height:100%;">
        <img class="vscs" :class="ci == i?'xx':'bb'" src="../../assets/ccscsqw.png"/>
      </li>
    </ul>

    <el-drawer title="上传图片" :visible.sync="drawer" :with-header="false" size="500px">
      <div class="cover" style="margin-top:20px;">
        <span style="color: #000;font-size: 14px;">上传图片</span>
        <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" accept="image/jpeg,image/gif,image/png">
          <img v-if="imageUrl" :src="imageUrl" class="avatar"/>
          <i v-else class="el-icon-plus avatar-uploader-icon">
            <span style="font-size: 16px;">点击选择封面</span>
          </i>
        </el-upload>
        <p>建议尺寸375*812</p>
      </div>
      <div>
        <span style="margin-left:20px">模版类型</span>
        <el-radio style="margin-left:20px" v-model="templateType" label="1">活动</el-radio>
        <el-radio v-model="templateType" label="2">教育培训</el-radio>
      </div>
      <el-button type="primary" style="margin-top:10px;margin-left:40%" @click="cvh()">确定</el-button>
    </el-drawer>

  </div>
</template>
<script>
export default {
    data() {
      return {
        file:'',
        imageUrl:'',
        drawer: false,
        templateType:'1',
        options: [{
          value: '2',
          label: '教育培训'
        }, {
          value: '1',
          label: '活动'
        }],
        data:[],
        ci:'2',
        keyNo:''
      }
    },
    methods: {
      cvh(){
        var from = new FormData();
        from.append('templateStatus', 1);
        from.append('templateType', this.templateType);
        from.append('imageFile', this.file.raw);

        this.$Http_Post('/edu/train/uploadCertificateTemplate', from, {'Content-Type': 'multipart/form-data',}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.drawer = false;
            this.loading();
            this.Global.request_successful(res.Message);
          } else {
            this.drawer = false;
            this.Global.request_failure(res.Message);
          }
        })

      },

      handleChange(file, fileList) {
        if (file.raw.type == 'image/jpeg' || file.raw.type == 'image/gif' || file.raw.type == 'image/png') {
          this.imageUrl = URL.createObjectURL(file.raw)
          this.file = file;
        } else {
          this.$message({type: 'error',message: '文件格式错误，请上传图片',})
        }
      },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      beforeAvatarUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 8
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
        }
        return isLt2M;
      },
      qh(i,keyNo){
        this.ci = i;
        this.keyNo = keyNo;
      },
      qdfun(){
        this.$Http_Post('/certificateTemplate/update', {keyNo:this.keyNo,templateType:this.templateType}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message)
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      },
      loading(){
        this.$Http_Post('certificateTemplate/list', {name:this.templateType}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.data = res.Data;
            res.Data.forEach((item,i) => {
              if(item.templateStatus == 1){
                this.ci = i;
                this.keyNo = item.keyNo;
              }
            });
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }
    },
    mounted() {
      this.loading();
    }
}
</script>
<style>
.Certificate_setting{width: 100%;height: 100%;background-color: #fff;}
.Certificate_setting ul li{float: left;width: 250px;height: 500px;margin-left: 20px;margin-top: 20px;position: relative;}
.Certificate_setting ul li .xx{display: block;}
.Certificate_setting ul li .bb{display: none;}
.Certificate_setting ul li .vscs{position: absolute;top:15px;right: 15px;}
.avatar{width: 215px;
    height: 322px !important;
    display: block;}
.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover {border-color: #409eff;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 320px;line-height: 320px;text-align: center;border: 1px solid #d1d1d1;}
.avatar {width: 215px;height: 148px;display: block;}
.cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 335px;}
.avatar-uploader {position: absolute;top: 0px;left: 90px;}
.cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 330px;width: 350px;}
</style>

